import { render, staticRenderFns } from "./HangingView.vue?vue&type=template&id=067fa498&"
import script from "./HangingView.vue?vue&type=script&lang=js&"
export * from "./HangingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports